import { newToolFilterOAuthMcp } from "../oauth.ts";

export const calendlyMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://calendly.com/media/favicon/apple-touch-icon.png",
  url: "https://mcp.calendly.com",
  label: "Calendly",
});
